__turbopack_context__.v({
  "carret": "input-module__tTs2qq__carret",
  "icon": "input-module__tTs2qq__icon",
  "input": "input-module__tTs2qq__input",
  "secondary": "input-module__tTs2qq__secondary",
  "select": "input-module__tTs2qq__select",
  "small": "input-module__tTs2qq__small",
  "suffix": "input-module__tTs2qq__suffix",
  "textarea": "input-module__tTs2qq__textarea",
  "wrapper": "input-module__tTs2qq__wrapper",
});
